/**
 * Compute the y-axis upper bound as the next multiple of 10 above
 * the tallest bar. For stacked traces, the tallest bar is the sum
 * of all trace values at the same x-index.
 */
export const computeYAxisMax = (
  traces: readonly { y?: readonly number[] }[]
): number => {
  const MIN = 10;
  if (traces.length === 0) return MIN;

  const traceLength = traces[0]?.y?.length ?? 0;
  if (traceLength === 0) return MIN;

  let maxStack = 0;
  for (let i = 0; i < traceLength; i++) {
    let stack = 0;
    for (const trace of traces) {
      stack += trace.y?.[i] ?? 0;
    }
    maxStack = Math.max(maxStack, stack);
  }

  if (maxStack <= 0) return MIN;

  const rounded = Math.ceil(maxStack / 10) * 10;
  return Math.max(rounded, MIN);
};
